let ActivityTypeService = function ($http, $rootScope) {

    var activityTypeArray = [];

    /**
     * Get a list of activity types for select lists
     */

    let data = function () {
        if (activityTypeArray.length === 0) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            activityTypeArray = $http.get(WEBSERVICEURL + '/dataagility/api/service.activity/selectlist')
                .then(function (response) {
                    return response.data;
                });
        }

        return activityTypeArray;
    }

    return { data };

};

export default ActivityTypeService;



// WEBPACK FOOTER //
// ./client/app/common/services/activityType.service.js